/*
 * @Author: Teemo Ding
 * @Date: 2021-12-01 11:57:07
 * @LastEditTime: 2021-12-10 15:12:20
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/StoreVoucher/Detail/VoucherType/index.tsx
 */
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum EMethod {
  Percentage = 'Percentage',
  Reduction = 'Reduction',
  Gift = 'Gift',
  Shipping = 'Shipping',
  GiftPurchase = 'GiftPurchase',
}

const Item = Form.Item;
const radioName = ['voucherType'];

const Method = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      title={getI18n('general.type')}>
      <Item
        name={radioName}
        rules={[
          { required: true, message: getI18n('general.pleaseselectavalue') },
        ]}>
        <RadioGroup className={css.radioGroup} disabled={disabled}>
          <RadioItem className={css.radio} value={EMethod.Percentage}>
            {getI18n('general.percentageOff')}
          </RadioItem>
          <RadioItem className={css.radio} value={EMethod.Reduction}>
            {getI18n('general.fixedReductionAmount')}
          </RadioItem>
          <RadioItem value={EMethod.Shipping} className={css.radio}>
            {getI18n('voucher.storeVoucherList_config.shippingDiscount')}
          </RadioItem>
          <RadioItem value={EMethod.Gift}>
            {getI18n('voucher.storeVoucherList_config.freeItems')}
          </RadioItem>
        </RadioGroup>
      </Item>
    </SectionWrapper>
  );
};
export default Method;
